import { render, staticRenderFns } from "./OffersCds.vue?vue&type=template&id=649520f0"
import script from "./OffersCds.vue?vue&type=script&lang=js"
export * from "./OffersCds.vue?vue&type=script&lang=js"
import style0 from "./OffersCds.vue?vue&type=style&index=0&id=649520f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports